import { PersonalizedFilter } from '../../GraphQL/Queries/types';

const fetchPersonalisedContentQueryParams = (
  personalizationType: string,
  personalizationMetaData: string,
  sourceType: string,
  id: string,
  country: string,
  languages: string,
  translation: string
) => {
  const queryParams = {
    filter: {
      personalizationType,
      personalizationMetaData,
      sourceType,
      id,
      country,
      languages,
      translation
    } as PersonalizedFilter
  };
  return queryParams;
};

export default fetchPersonalisedContentQueryParams;
